import React from 'react';
import { ArticleParagraph1, useDeviceType } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import styles from './styles.css';
import cn from 'clsx';

interface IMultiOfferBtnProps {
  text: string;
  isToggle: boolean;
  handler: () => void;
}

export const MultiOfferBtn: React.FC<IMultiOfferBtnProps> = ({ text, isToggle, handler }) => {
  const deviceType = useDeviceType();

  return (
    <button
      className={cn(styles['btn'], isToggle && styles['active'], styles[deviceType])}
      title={text}
      onClick={handler}
    >
      <ArticleParagraph1 color={'current_color'}>{text}</ArticleParagraph1>
      <span className={styles['icon']}>
        <IconActionChevronDownSmall16 color={'icon-main-default'} />
      </span>
    </button>
  );
};
